<template>
  <div>
    <div class="panel panel-primary">
      <div
        class="panel-heading"
        @click="formInfoPessoais.showForm = !formInfoPessoais.showForm"
      >
        4.1 - INFORMAÇÕES PESSOAIS
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              formInfoPessoais.showForm
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="formInfoPessoais.showForm" class="panel-body">
        <div class="row">
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoPessoais.nome"
              :form="formInfoPessoais"
              label="Nome"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-2">
            <form-helper
              :inputVar="formInfoPessoais.dataNascimento"
              :form="formInfoPessoais"
              type="date"
              label="Data de Nascimento"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-2">
            <form-helper
              :inputVar="formInfoPessoais.numeroDocumento"
              :form="formInfoPessoais"
              label="Nº do Documento"
              placeholder="Digite"
              maxlength="11"
              :disabled="formInfoPessoais.disabledDocumento"
            />
          </div>
          <div class="col-md-2">
            <form-helper
              :inputVar="formInfoPessoais.rendaMensal"
              :form="formInfoPessoais"
              type="money"
              validationType="Negative"
              label="Renda Mensal"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoPessoais.nomeMae"
              :form="formInfoPessoais"
              validationType="name"
              label="Nome da Mãe"
              placeholder="Digite"
              :disabled="formInfoPessoais.disabledNomeMae"
            />
          </div>
          <div class="col-md-2">
            <form-helper
              :inputVar="formInfoPessoais.telefone"
              :form="formInfoPessoais"
              label="Telefone Celular"
              placeholder="(##) #####-####"
              :mask="'(##) #####-####'"
              :disabled="true"
            />
          </div>
          <div class="col-md-4">
            <form-helper
              :inputVar="formInfoPessoais.email"
              :form="formInfoPessoais"
              validationType="email"
              label="Email"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-primary">
      <div
        class="panel-heading"
        @click="formInfoInstalacao.showForm = !formInfoInstalacao.showForm"
      >
        4.2 - ENDEREÇO DE INSTALAÇÃO
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              formInfoInstalacao.showForm
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="formInfoInstalacao.showForm" class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.cep"
              :form="formInfoInstalacao"
              label="CEP"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableCep || currentStep > 4"
            />
          </div>
          <div class="col-md-9">
            <form-helper
              :inputVar="formInfoInstalacao.endereco"
              :form="formInfoInstalacao"
              label="Endereço"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableEndereco"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.numero"
              :form="formInfoInstalacao"
              label="Número"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableNumero"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.complemento"
              :form="formInfoInstalacao"
              label="Complemento"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableComplemento"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoInstalacao.bairro"
              :form="formInfoInstalacao"
              label="Bairro"
              placeholder="Digite"
              :disabled="formInfoInstalacao.disableBairro"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.estado"
              :form="formInfoInstalacao"
              label="Estado"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoInstalacao.cidade"
              :form="formInfoInstalacao"
              label="Cidade"
              placeholder="Digite"
              :disabled="true"
            />
          </div>
          <div class="col-md-6">
            <div class="choose-checkbox-methods">
              <label class="checkbox-option" style="margin-top: 30px">
                <input
                  name="aceitoTerms"
                  value="1"
                  type="checkbox"
                  checked
                  v-model="formInfoInstalacao.mesmoEndereco"
                  :disabled="
                    formInfoInstalacao.disableMesmoEndereco || currentStep > 4
                  "
                />
                <span>
                  Endereço de cobrança é o mesmo endereço de instalação
                </span>
              </label>
            </div>
          </div>
        </div>
        <div class="row" v-if="formInfoInstalacao.mesmoEndereco">
          <div class="col-md-12">
            <button
              v-if="currentStep == 4"
              aria-label="Anterior"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="previousStep()"
            >
              <i class="fa fa-chevron-left"></i> Anterior
            </button>

            <button
              v-if="!loading && currentStep == 4"
              aria-label="Próximo"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="sendProposta()"
            >
              Enviar Proposta <i class="fa fa-chevron-right"></i>
            </button>

            <Loader
              v-if="loading"
              style="margin-top: -5px; margin-left: 20px"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel-primary" v-if="!formInfoInstalacao.mesmoEndereco">
      <div
        class="panel-heading"
        @click="formInfoCobranca.showForm = !formInfoCobranca.showForm"
      >
        4.3 - ENDEREÇO DE COBRANÇA
        <span class="pull-right">
          <i
            style="font-size: 1.5em"
            :class="
              formInfoCobranca.showForm
                ? 'fa fa-arrow-down'
                : 'fa fa-arrow-right'
            "
            aria-hidden="true"
          ></i>
        </span>
      </div>
      <div v-if="formInfoCobranca.showForm" class="panel-body">
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.cep"
              :form="formInfoCobranca"
              :mask="'#####-###'"
              label="CEP"
              placeholder="Digite"
              :disabled="formInfoCobranca.disableCep"
            />
          </div>
          <div class="col-md-9">
            <form-helper
              :inputVar="formInfoCobranca.endereco"
              :form="formInfoCobranca"
              label="Endereço"
              placeholder="Digite"
              :disabled="formInfoCobranca.disableEndereco"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.numero"
              :form="formInfoCobranca"
              label="Número"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.complemento"
              :form="formInfoCobranca"
              label="Complemento"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-6">
            <form-helper
              :inputVar="formInfoCobranca.bairro"
              :form="formInfoCobranca"
              label="Bairro"
              placeholder="Digite"
              :disabled="formInfoCobranca.disableBairro"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.estado"
              :form="formInfoCobranca"
              label="Estado"
              placeholder="Digite"
            />
          </div>
          <div class="col-md-3">
            <form-helper
              :inputVar="formInfoCobranca.cidade"
              :form="formInfoCobranca"
              label="Cidade"
              placeholder="Digite"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button
              v-if="currentStep == 4"
              aria-label="Anterior"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="previousStep()"
            >
              <i class="fa fa-chevron-left"></i> Anterior
            </button>

            <button
              v-if="!loading && currentStep == 4"
              aria-label="Próximo"
              style="float: left; margin-right: 1em"
              class="btn btn-primary"
              @click="sendProposta()"
            >
              Enviar Proposta <i class="fa fa-chevron-right"></i>
            </button>

            <Loader
              v-if="loading"
              style="margin-top: -5px; margin-left: 20px"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormHelper from "@/components/partials/FormHelper.vue";
import Endereco from "@/services/Endereco";
import SolAgoraService from "@/services/SolAgoraService";

const respostaPadraoErroGenerico =
  "Serviço indisponível, tente novamente mais tarde.";

export default {
  name: "SolAgoraFisico",
  props: {
    total: { type: Number, default: 0 },
    cliente: { type: Object, default: null },
    cepCobranca: { type: String, default: "" },
    codigoPedido: { type: String, default: 0 },
    resultadoSimulacao: { type: Object, default: null },
    currentStep: { type: Number, default: 0 },
    idProject: { type: String, default: "" },
    token: { type: String, default: null },
  },
  components: {
    FormHelper,
  },
  data() {
    return {
      formInfoPessoais: {
        showForm: true,
        nome: new this.$formInput(true),
        numeroDocumento: new this.$formInput(true),
        rendaMensal: new this.$formInput(true),
        email: new this.$formInput(true),
        telefone: new this.$formInput(true),
        nomeMae: new this.$formInput(true),
        dataNascimento: new this.$formInput(true),
        disabledNomeMae: true,
        disabledDocumento: true,
        attemptSubmit: false,
      },
      formInfoInstalacao: {
        showForm: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        cidade: new this.$formInput(true),
        disableCep: true,
        disableEndereco: true,
        disableNumero: true,
        disableComplemento: true,
        disableBairro: true,
        mesmoEndereco: true,
        disableMesmoEndereco: false,
        attemptSubmit: false,
      },
      formInfoCobranca: {
        showForm: true,
        cep: new this.$formInput(true),
        endereco: new this.$formInput(true),
        numero: new this.$formInput(true),
        complemento: new this.$formInput(false),
        bairro: new this.$formInput(true),
        estado: new this.$formInput(true),
        cidade: new this.$formInput(true),
        disableCep: false,
        disableEndereco: false,
        disableBairro: false,
        attemptSubmit: false,
      },
      isLoaded: false,
      loading: false,
    };
  },
  async mounted() {
    this.load();
  },
  methods: {
    load: async function () {
      if (!this.isLoaded) {
        this.setDadosCliente();
        await this.setEnderecoInstalacao();

        this.isLoaded = true;
      }
    },

    previousStep: function () {
      this.$emit("previous");
    },

    async sendProposta() {
      try {
        this.loading = true;

        this.formInfoPessoais.attemptSubmit = true;
        this.formInfoInstalacao.attemptSubmit = true;
        this.formInfoCobranca.attemptSubmit =
          !this.formInfoInstalacao.mesmoEndereco;
        let totalErrors = this.formErrors;

        if (totalErrors) {
          swal({
            title: "Preencha os campos obrigatórios",
            text: "Números de campos a serem preenchidos: " + totalErrors,
            icon: "warning",
          });

          return;
        }

        const pev_codigo = this.codigoPedido.toString().split("-")[0];
        const res = await SolAgoraService.SendProposal({
          apiUrl: this.$apiUrl,
          token: this.token,
          idProject: this.idProject,
          resultadoSimulacao: this.resultadoSimulacao,
          installationAddress: {
            cep: this.formInfoInstalacao.cep.value,
            streetAddress: this.formInfoInstalacao.endereco.value,
            state: this.formInfoInstalacao.estado.value,
            neighborhood: this.formInfoInstalacao.bairro.value,
            city: this.formInfoInstalacao.cidade.value,
            number: this.formInfoInstalacao.numero.value,
            complement: this.formInfoInstalacao.complemento.value,
          },
          address: {
            cep: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.cep.value
              : this.formInfoCobranca.cep.value,
            streetAddress: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.endereco.value
              : this.formInfoCobranca.endereco.value,
            state: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.estado.value
              : this.formInfoCobranca.estado.value,
            neighborhood: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.bairro.value
              : this.formInfoCobranca.bairro.value,
            city: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.cidade.value
              : this.formInfoCobranca.cidade.value,
            number: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.numero.value
              : this.formInfoCobranca.numero.value,
            complement: this.formInfoInstalacao.mesmoEndereco
              ? this.formInfoInstalacao.complemento.value
              : this.formInfoCobranca.complemento.value,
          },
          regionalDocument: this.formInfoPessoais.numeroDocumento.value,
          motherName: this.formInfoPessoais.nomeMae.value,
          hardwareCost: this.total,
          laborCost: this.resultadoSimulacao.laborCost,
          power: 1,
          codigoPedido: pev_codigo,
        });

        if (!res) {
          swal({
            title: "Aviso",
            text: respostaPadraoErroGenerico,
            icon: "warning",
          });
          return;
        }

        if (res.message) {
          swal({
            title: "Aviso",
            text: res.message,
            icon: "warning",
          });
          return;
        }

        if (!res.data.Success) {
          swal({
            title: "Proposta Negada",
            text: res.data.Message,
            icon: "warning",
          });
          return;
        }

        swal({
          title: "Proposta registrada com sucesso!",
          icon: "success",
        });

        this.$emit("setResultadoProposta", res.data);
        this.$emit("next");
      } finally {
        this.loading = false;
      }
    },

    setDadosCliente() {
      this.formInfoPessoais.nome.value = this.cliente.CLI_RAZAOSOCIAL;
      if (this.cliente.CLI_RG != null && this.cliente.CLI_RG != "") {
        this.formInfoPessoais.numeroDocumento.value = this.cliente.CLI_RG;
        this.formInfoPessoais.disabledDocumento = true;
      } else this.formInfoPessoais.disabledDocumento = false;

      this.formInfoPessoais.email.value = this.cliente.CLI_EMAIL;

      if (this.cliente.CLI_FILIACAOMAE) {
        this.formInfoPessoais.nomeMae.value =
          this.cliente.CLI_FILIACAOMAE.substring(0, 35);

        if (this.cliente.CLI_FILIACAOMAE.trim().split(" ").length > 1)
          this.formInfoPessoais.disabledNomeMae = true;
        else this.formInfoPessoais.disabledNomeMae = false;
      } else {
        this.formInfoPessoais.disabledNomeMae = false;
      }

      this.formInfoPessoais.dataNascimento.value =
        this.cliente.CLI_DATANASCIMENTOFUNDACAO;
      this.formInfoPessoais.telefone.value = this.cliente.CLI_FONE;
      this.formInfoPessoais.rendaMensal.value =
        this.resultadoSimulacao.monthlyIncome;
    },

    async setEnderecoInstalacao() {
      this.formInfoInstalacao.disableCep = this.cliente.CLI_CEP !== "";
      this.formInfoInstalacao.cep.value = this.cliente.CLI_CEP;

      this.formInfoInstalacao.disableEndereco =
        this.cliente.CLI_ENDERECO !== "";
      this.formInfoInstalacao.endereco.value = this.cliente.CLI_ENDERECO;

      this.formInfoInstalacao.numero.value = this.cliente.CLI_NUMEROENDERECO;
      this.formInfoInstalacao.disableNumero =
        this.cliente.CLI_NUMEROENDERECO !== "";

      this.formInfoInstalacao.complemento.value =
        this.cliente.CLI_COMPLEMENTOENDERECO;
      this.formInfoInstalacao.disableComplemento =
        this.cliente.CLI_COMPLEMENTOENDERECO !== "";

      this.formInfoInstalacao.disableBairro = this.cliente.CLI_BAIRRO !== "";
      this.formInfoInstalacao.bairro.value = this.cliente.CLI_BAIRRO;

      this.formInfoInstalacao.estado.value = this.cliente.EST_UF;
      this.formInfoInstalacao.cidade.value = this.cliente.CLI_CIDADE;

      this.formInfoInstalacao.mesmoEndereco =
        this.cliente.CLI_CEP.replace("-", "") ===
        this.cepCobranca.replace("-", "");

      if (!this.formInfoInstalacao.mesmoEndereco) {
        this.formInfoCobranca.cep.value = this.cepCobranca;
      }
      this.formInfoInstalacao.disableMesmoEndereco = true;
    },
  },
  watch: {
    "formInfoInstalacao.cep.value": async function (val) {
      if (val.length !== 9 || this.formInfoInstalacao.disableCep) return;

      const address = await Endereco.buscaCEP(val);

      if (!address) {
        swal({
          title: "Aviso",
          text: "O CEP informado não é válido.",
          icon: "warning",
        });

        return;
      }

      this.formInfoInstalacao.disableEndereco = address.logradouro !== "";
      this.formInfoInstalacao.endereco.value = address.logradouro;
      this.formInfoInstalacao.disableBairro = address.bairro !== "";
      this.formInfoInstalacao.bairro.value = address.bairro;
      this.formInfoInstalacao.estado.value = address.uf;
      this.formInfoInstalacao.cidade.value = address.localidade;
    },

    "formInfoCobranca.cep.value": async function (val) {
      if (val.length !== 9) return;

      const address = await Endereco.buscaCEP(val);

      if (!address) {
        swal({
          title: "Aviso",
          text: "O CEP informado não é válido.",
          icon: "warning",
        });

        return;
      }

      this.formInfoCobranca.disableEndereco = address.logradouro !== "";
      this.formInfoCobranca.endereco.value = address.logradouro;
      this.formInfoCobranca.disableBairro = address.bairro !== "";
      this.formInfoCobranca.bairro.value = address.bairro;
      this.formInfoCobranca.estado.value = address.uf;
      this.formInfoCobranca.cidade.value = address.localidade;
    },
  },
  computed: {
    formErrors: function () {
      let totalErrors = 0;

      let errors = Object.keys(this.formInfoPessoais).filter(
        (key) =>
          this.formInfoPessoais[key].validation &&
          !this.formInfoPessoais[key].validation.status
      );
      totalErrors += errors.length;

      errors = Object.keys(this.formInfoInstalacao).filter(
        (key) =>
          this.formInfoInstalacao[key].validation &&
          !this.formInfoInstalacao[key].validation.status
      );
      totalErrors += errors.length;

      if (!this.formInfoInstalacao.mesmoEndereco) {
        errors = Object.keys(this.formInfoCobranca).filter(
          (key) =>
            this.formInfoCobranca[key].validation &&
            !this.formInfoCobranca[key].validation.status
        );
        totalErrors += errors.length;
      }

      return totalErrors;
    },
  },
};
</script>